import React from "react";
import "./Showcase.scss";
import { H3 } from "../../ui/Typography";
import { TabPane, Tabs } from "../../ui";
import { ArrowRight } from "../../ui/icons/Icons";
import { Breadcrumb, BreadcrumbItem } from "../../ui/breadcrumb";
import Pagination from "../../ui/pagination/Pagination";

function ShowcaseTabs() {
  const [page, setPage] = React.useState(1);
  return (
    <>
      <div className="showcase-wrapper">
        <H3>Tabs</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>font 16 Px</th>
                <th>font 20Px</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <Tabs size="md" defaultIndex={0}>
                    <TabPane title="Header1">
                      Header1 Lorem ipsum dolor sit amet, consectetur adipiscing
                      elit. Donec blandit justo sapien, id dapibus neque cursus
                      posuere. Donec bibendum, quam sed gravida convallis, erat
                      nisi hendrerit felis, non vestibulum massa massa in risus.
                    </TabPane>
                    <TabPane title="Header2">
                      Header2 Lorem ipsum dolor sit amet, consectetur adipiscing
                      elit. Donec blandit justo sapien, id dapibus neque cursus
                      posuere. Donec bibendum, quam sed gravida convallis, erat
                      nisi hendrerit felis, non vestibulum massa massa in risus.
                    </TabPane>
                    <TabPane title="Header3">
                      Header3 Lorem ipsum dolor sit amet, consectetur adipiscing
                      elit. Donec blandit justo sapien, id dapibus neque cursus
                      posuere. Donec bibendum, quam sed gravida convallis, erat
                      nisi hendrerit felis, non vestibulum massa massa in risus.
                    </TabPane>
                  </Tabs>
                </td>
                <td>
                  <Tabs size="lg" defaultIndex={0}>
                    <TabPane title="Header1">
                      Header1 Lorem ipsum dolor sit amet, consectetur adipiscing
                      elit. Donec blandit justo sapien, id dapibus neque cursus
                      posuere. Donec bibendum, quam sed gravida convallis, erat
                      nisi hendrerit felis, non vestibulum massa massa in risus.
                    </TabPane>
                    <TabPane title="Header2">
                      Header2 Lorem ipsum dolor sit amet, consectetur adipiscing
                      elit. Donec blandit justo sapien, id dapibus neque cursus
                      posuere. Donec bibendum, quam sed gravida convallis, erat
                      nisi hendrerit felis, non vestibulum massa massa in risus.
                    </TabPane>
                    <TabPane title="Header3">
                      Header3 Lorem ipsum dolor sit amet, consectetur adipiscing
                      elit. Donec blandit justo sapien, id dapibus neque cursus
                      posuere. Donec bibendum, quam sed gravida convallis, erat
                      nisi hendrerit felis, non vestibulum massa massa in risus.
                    </TabPane>
                  </Tabs>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="showcase-wrapper">
        <H3>Breadcrumb</H3>
        <div className="showcase-inner">
          <table className="showcase-table">
            <tbody>
              <tr>
                <td></td>
                <th>12px font</th>
                <th>16px font</th>
                <th>20px font</th>
                <th>24px font</th>
              </tr>
              <tr>
                <th>Default</th>
                <td>
                  <Breadcrumb separator={ArrowRight} size="sm">
                    <BreadcrumbItem to="/">Tab 1</BreadcrumbItem>
                    <BreadcrumbItem to="/showcase/buttons">
                      Tab 2
                    </BreadcrumbItem>
                    <BreadcrumbItem>Tab 3</BreadcrumbItem>
                  </Breadcrumb>
                </td>
                <td>
                  <Breadcrumb separator={ArrowRight} size="md">
                    <BreadcrumbItem to="/">Tab 1</BreadcrumbItem>
                    <BreadcrumbItem to="/showcase/buttons">
                      Tab 2
                    </BreadcrumbItem>
                    <BreadcrumbItem>Tab 3</BreadcrumbItem>
                  </Breadcrumb>
                </td>
                <td>
                  <Breadcrumb separator={ArrowRight} size="lg">
                    <BreadcrumbItem to="/">Tab 1</BreadcrumbItem>
                    <BreadcrumbItem to="/showcase/buttons">
                      Tab 2
                    </BreadcrumbItem>
                    <BreadcrumbItem>Tab 3</BreadcrumbItem>
                  </Breadcrumb>
                </td>
                <td>
                  <Breadcrumb separator={ArrowRight} size="xl">
                    <BreadcrumbItem to="/">Tab 1</BreadcrumbItem>
                    <BreadcrumbItem to="/showcase/buttons">
                      Tab 2
                    </BreadcrumbItem>
                    <BreadcrumbItem>Tab 3</BreadcrumbItem>
                  </Breadcrumb>
                  <Pagination
                    currentPage={3}
                    totalPages={5}
                    onPageChange={(page) => console.log(page)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default ShowcaseTabs;
